module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TF - French Southern Territories.22d134a4.svg";